/**
 * Public read-only demo mode. Built with REACT_APP_DEMO=1; the normal app build is unaffected.
 * Every GET is answered from static fixtures recorded from a real run on the fictional
 * `demo_dossier_v1.pdf` (see scripts/demo/record_fixtures.py). Every write is refused.
 */
export const DEMO = process.env.REACT_APP_DEMO === "1";
export const DEMO_DATA_BASE = `${process.env.PUBLIC_URL || ""}/demo-data`;
